<template>
  <v-navigation-drawer fixed app class="menu" width="300" floating >
    <v-list dense nav class="d-flex flex-column pt-5 pb-1 px-4 sidebar-menu" style="height: 100%;">

      <!-- Contenido principal -->
      <div>
        <v-list-item class="px-0 mb-0" @click="editProfile()" >
          <v-list-item-content class="py-0">
            <v-list-item class="px-0 pl-6">
              <img
                  src="../../assets/img/logo-admin.png"
                  alt="Logo"
                  style="max-height: 65px; object-fit: contain;"
              />
            </v-list-item>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group
            class="mt-6"
        >
          <!-- Grupo con hijos -->
          <v-list-group
              class="group-menu"
              v-for="(item, i) in list_menu"
              v-if="item.children && item.children.length"
              :key="`group-${i}`"
              :value="groupModels[i]"
              @update:input-value="groupModels[i] = $event"
          >
          <template v-slot:appendIcon>
            <div class="d-flex align-center">
              <v-icon style="width: 16px; height: 16px;">
                $caretDownIcon
              </v-icon>
            </div>
          </template>
            <template v-slot:activator>
             <div class="d-flex align-center flex-grow-1 overflow-hidden">
                <v-list-item-icon class="me-3 my-0 icon-left">
                  <div>
                    <v-icon
                      v-if="
                        typeof item.icon === 'string' &&
                          (item.icon.startsWith('$') ||
                            item.icon.startsWith('fa') ||
                            item.icon.startsWith('mdi'))
                      "
                    > {{item.icon }}</v-icon>
                    <img v-else  :src="item.icon" alt="" />
                  </div>
                </v-list-item-icon>
                <v-list-item-title class="text-menu text-truncate min-w-0">{{ item.title }}</v-list-item-title>
             </div>
            </template>

            <v-list-item
                v-for="(sub, j) in item.children"
                :key="`sub-${i}-${j}`"
                link
                @click="/*goToRoute(sub)*/"
                :to="sub.link"
                exact
                :class="{ 'v-item--active v-list-item--active': isActivePrefix(sub.link) }"
            >
              <v-list-item-content>
                <v-list-item-title class="text-menu ml-9">{{ sub.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Item simple -->
          <v-list-item
              v-for="(item, i) in list_menu"
              v-if="!item.children || !item.children.length"
              :key="`item-${i}`"
              link
              @click="goToRoute(item)"
          >
            <v-list-item-icon>
              <div class="icon">
                <img :src="item.icon" alt="" />
              </div>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="custom-title">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

      </div>

      <!-- Botón Cerrar Sesión al fondo -->
      <div class="mt-auto">
        <v-list-item class="px-0">
          <v-row no-gutters>
            <v-btn class="px-2 text-menu" text   @click="logout"
                   v-if="this.$store.getters['Authenticate/isLoggedIn']">
              <img
                  class="mr-1"
                  src="../../assets/img/icons/SignOut.png"
                  alt="Logo"
                  style=" object-fit: contain;"
              /> Cerrar Sesión
            </v-btn>
          </v-row>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
import route from "@/router/index";
import { mapState } from "vuex";
import SiteFooter from "@/components/layout/footer.vue";

export default {
  /* created() {
    this.$store.dispatch("Authenticate/me").then((user)=>{
      this.setMenu(user);
    });
  }, */
  data: () => ({
    list_menu: [],
    list_submenu: [],
    subGroup: false,
    groupModels: {},
  }),
  watch: {
    $route: {
      handler(to, from) {
        this.$store.dispatch("Notifications_cms/getListAllNotifications", {
          show_all: "enable",
          is_read: false,
        });
        if (this.list_menu.length > 0) {
          // this.syncOpenMenuWithRoute(this.$route.path);
          this.syncMenuWithRoute(this.$route.path);
        }
      },
      immediate: true,
    },
    user: {
      handler(val) {
        if(val && val.id){
          this.setMenu(val);
        }
      },
      immediate: true,
    },

  },
  components: { SiteFooter },
  computed: {

    role_name() {
      return this.user && this.user.role ? this.user.role.label : "";
    },
    ...mapState({
      list: (state) => state.Menu.list,
      sub_list: (state) => state.Menu.sub_list,
      selected_menu: (state) => state.Menu.selected_menu,
      user: (state) => state.Authenticate.user,
    }),
  },
  methods: {
    goToRoute(item, index) {
      this.selected = index;
      route.push(item.link).catch(() => { });
    },
    syncOpenMenuWithRoute(path) {
      let foundIndex = null;

      this.list_menu.forEach((item, i) => {
        if (item.children && item.children.length) {
          item.children.forEach((sub, j) => {
            if (path === sub.link || path.startsWith(sub.link + '/')) {
              // foundIndex = `sub-${i}-${j}`;
              foundIndex = i;
              item.active = true;
            }
          });
        } else if (item.link === path) {
          foundIndex = `item-${i}`;
        }
      });

      if (foundIndex) {
        this.$store.commit("Menu/set_selected_menu", foundIndex);
      }
    },
    syncMenuWithRoute(path) {
      Object.keys(this.groupModels).forEach(i => {
        this.$set(this.groupModels, i, false);
      });

      this.list_menu.forEach((item, i) => {
        if (!item.children) return;

        const match = item.children?.some(sub => {
          return path === sub.link || path.startsWith(sub.link + '/');
        });
        if (match) {
          this.$set(this.groupModels, i, true);
        }
      });
    },
    isActivePrefix(baseLink) {
      const path = this.$route.path || '';
      return path === baseLink || path.startsWith(baseLink + '/');
    },
    isParentActive(i) {
      const item = this.list_menu[i];
      if (!item || !item.children) return false;

      return item.children.some(sub =>
          this.$route.path === sub.link ||
          this.$route.path.startsWith(sub.link + '/')
      );
    },
    editProfile() {
      this.$router.push("/admin/profile");
    },
    logout() {
      this.$store.dispatch("Authenticate/logout");
    },
    setMenu(user) {
      const access = user.access_menus || [];
      console.log("access", access);
      
      if (user.role === "admin") {
        this.list_menu = this.list;
        this.groupModels = {};
        this.list_menu.forEach((_, i) => {
          this.$set(this.groupModels, i, false);
        });
        this.syncOpenMenuWithRoute(this.$route.path);
        this.syncMenuWithRoute(this.$route.path);
      } else {
        // ✅ Filtrar padres, pero quedarnos solo con los hijos permitidos
        this.list_menu = this.list
            .map(parent => {
              const allowedChildren = parent.children.filter(child =>
                  access.includes(child.link) // comparar por link
              );
              if (allowedChildren.length > 0) {
                return { ...parent, children: allowedChildren };
              }
              return null;
            })
            .filter(Boolean);

        // ✅ Redirige al primer hijo disponible
        const firstLink =
            this.list_menu[0]?.children?.[0]?.link || this.list_menu[0]?.link;

        if (firstLink) {
          this.$router.push(firstLink).catch(() => {});
        }
      }
    }

  },
};
</script>
